import classNames from 'classnames/bind';
import styles from './styles.module.scss';

interface SegmentProps {
  children: React.ReactNode;
  collapsed?: boolean;
}

const Segment = ({ children, collapsed = false }: SegmentProps) => {
  const cx = classNames.bind(styles);

  return (
    <div className={cx({ segment: true, collapsed })} id="main-content">
      {children}
    </div>
  );
};

export default Segment;
